<template>
  <div class="flex flex-col max-h-[70vh]">
    <div class="flex items-center justify-between gap-2 border-b border-border px-4 py-3">
      <p class="text-sm font-semibold text-foreground">Notifications</p>
      <div class="flex items-center gap-2">
        <span class="text-xs text-muted-foreground">Show read</span>
        <Switch :model-value="historical" @update:model-value="$emit('toggle-historical')" />
      </div>
    </div>

    <div class="flex-1 overflow-y-auto p-2">
      <div v-if="!loading && notifications.length > 0" class="space-y-2">
        <button
          v-for="(notification, index) in notifications"
          :key="index"
          type="button"
          class="w-full text-left flex items-start gap-3 rounded-lg border border-border p-3 hover:bg-muted/50 transition-colors"
          :class="notification.interactedWith ? 'bg-muted/30 opacity-70' : 'bg-card'"
          @click="$emit('open', notification)"
        >
          <img v-if="notification.logoURL" :src="notification.logoURL" class="w-8 h-8 rounded border bg-white shrink-0" alt="" />
          <p class="text-sm text-foreground flex-1">{{ notification.message }}</p>
        </button>

        <Button
          v-if="!lastPage"
          variant="outline"
          size="sm"
          class="w-full"
          @click="$emit('load-more')"
        >Load more</Button>
      </div>

      <div v-else-if="!loading && notifications.length === 0" class="flex flex-col items-center justify-center py-10 px-4">
        <Bell class="w-12 h-12 mb-3 text-muted-foreground" />
        <p class="text-foreground text-center font-medium">You have no notifications</p>
        <p class="text-muted-foreground text-sm mt-1 text-center">
          All caught up! Check back later for new updates.
        </p>
      </div>

      <div v-else class="space-y-2">
        <Skeleton v-for="i in 5" :key="`ns${i}`" class="h-14" />
      </div>
    </div>
  </div>
</template>

<script>
import { Button, Switch, Skeleton } from '@boogi/ui'
import { Bell } from 'lucide-vue-next'

export default {
  name: 'NotificationsPanel',
  components: {
    Button,
    Switch,
    Skeleton,
    Bell,
  },
  props: {
    notifications: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    historical: { type: Boolean, default: false },
    lastPage: { type: Boolean, default: false },
  },
  emits: ['open', 'load-more', 'toggle-historical'],
}
</script>
